<template>
	<div
		v-if="show"
		class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
	>
		<div class="bg-base-100 p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
			<h2 class="text-xl font-bold mb-4">Nueva Versión Disponible</h2>
			<p class="mb-6">
				Una nueva versión de la aplicación está disponible. Por favor actualiza para continuar.
			</p>
			<div class="flex justify-end">
				<button
					@click="refresh"
					class="btn btn-primary btn-sm w-full no-animation"
				>
					Actualizar Ahora
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VersionUpdateModal',
	props: {
		show: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		refresh() {
			window.location.reload()
		}
	}
}
</script>
